module.exports = __webpack_public_path__ + "img/FrejaPartner.f55f1ab1.png";